/* eslint-disable react/jsx-sort-props */
import * as React from 'react';
import * as vars from '../../styles/variables';
import AccessibleSVG, { SVGProps } from '../../components/accessible-svg/AccessibleSVG';

/**
 * This is an auto-generated component and should not be edited
 * manually in contributor pull requests.
 *
 * If you have problems with this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Bug_report.md
 *
 * If there are missing features in this component:
 * - https://github.com/box/box-ui-elements/issues/new?template=Feature_request.md
 */

const MoveCopy16 = (props: SVGProps) => (
    <AccessibleSVG width={16} height={16} viewBox="0 0 16 16" {...props}>
        <path
            fill={vars.bdlGray50}
            fillRule="evenodd"
            d="M13 3c.557 0 .942.345.994.875L14 4v11H4V3h9zm-2-2v1H3v10H2V1h9zm-.5 9h-3c-.3 0-.5.2-.5.5 0 .267.158.454.404.493L7.5 11h3c.3 0 .5-.2.5-.5s-.2-.5-.5-.5zm0-3h-3c-.3 0-.5.2-.5.5 0 .267.158.454.404.493L7.5 8h3c.3 0 .5-.2.5-.5s-.2-.5-.5-.5z"
        />
    </AccessibleSVG>
);

export default MoveCopy16;
